import { DataService } from '../../../services/data_service';
import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WActionButton } from '../../../core/elements/WActionButton';

interface CustomRowNameProps extends React.ClassAttributes<any> {
    data: any;
    entity: string;
    id: string;
    name: string;
    position: number;
    styleButton?: React.CSSProperties;
}

interface CustomRowNameState {
    mouseOverButtons: number | string;
    name: string;
    tid: number;
}

export class CustomRowName extends React.Component<CustomRowNameProps, CustomRowNameState> {

    constructor(props: any) {
        super(props);
        this.state = {
            mouseOverButtons: undefined,
            name: undefined,
            tid: 0
        };
        this.onClickEdit = this.onClickEdit.bind(this);
    }

    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    componentDidMount(): void {
        this.init();
    }

    delData(): void {
        if (confirm(`Benutzerdefinierte Bezeichnung wirklich löschen?`)) {
            this.dataService.delData(
                IDs.ENT_CUSTOM_ROW_NAME, IDs.MOD_ETOOL, { tid: this.state.tid }, {},
                (res: any, success: boolean) => {
                    if (success) {
                        const name: string = (this.props.position === 0 ? 0 : this.props.position || '').toString();
                        const tid: number = 0;
                        this.setState({ tid, name }, () => {
                            this.triggerService.fire('reload', IDs.ENT_CUSTOM_ROW_NAME);
                            alert('Benutzerdefinierte Bezeichnung wurde gelöscht.');
                        });
                    }
                }
            );
        }
    }

    getStyle(): any {
        return ({
            row: {
                height: 14,
                margin: 0,
                marginLeft: 4,
                padding: 0,
                display: 'inline-flex',
                flexDirection: 'row',
                alignItems: 'center',
                boxSizing: 'border-box',
                position: 'relative'
            },
            button: {
                fontSize: '9pt',
                color: '1px solid var(--color-button-text)',
                maxWidth: 20,
                maxHeight: 20,
                margin: 0,
                marginTop: 4,
                marginLeft: 2,
                padding: 0,
                border: '1px solid var(--color-button-text)'
            }
        });
    }

    init(): void {
        const data: any = ((this.props.data || {})[IDs.ENT_CUSTOM_ROW_NAME] || [])
            .find((item: any) => item.key_row === this.props.entity && item.position === this.props.position) || {};
        const name: string = data.name || (this.props.position === 0 ? 0 : this.props.position || '').toString();
        const tid: number = data.tid || 0;
        this.setState({ name, tid });
    }

    onClickEdit(): void {
        const curName: string = (((this.props.data || {})[IDs.ENT_CUSTOM_ROW_NAME] || [])
            .find((item: any) => item.key_row === this.props.entity && item.position === this.props.position) || {}).name;
        const position: string = (this.props.position === 0 ? 0 : this.props.position || '').toString();
        let name: string = null;

        do {
            name = prompt(`"${position}" ersetzen durch:`, this.state.name);

            if (name === null || (name === this.state.name && curName)) {
                return;
            } else if (!(name || '').trim().length) {
                alert('Bitte geben Sie eine Bezeichnung ein!');
            } else if ((name || '').trim() === position) {
                alert('Bitte geben Sie andere Bezeichnung ein!');
            }
        } while ((!(name || '').trim().length && name !== null) || (name || '').trim() === position);
        this.setData(name);
    }

    render(): JSX.Element {
        if (!this.state.name) {
            return null;
        }
        const id: string = this.props.id || null;

        return <>
            <span style={{ display: 'inline-flex' }}
                onMouseEnter={() => this.setState({ mouseOverButtons: id })}
                onMouseLeave={() => this.setState({ mouseOverButtons: undefined })}
            >
                <span>{this.props.name} {this.state.name}</span>
                {this.state.mouseOverButtons === id &&
                    this.renderButtons()
                }
            </span>
        </>;
    }

    renderButtons(): JSX.Element {
        const styles: any = this.getStyle();

        return (
            <span style={styles.row}>
                <WActionButton
                    label='Umbenennen'
                    tooltip='Bezeichnung umbenennen'
                    key='rename'
                    action='edit'
                    style='small'
                    styleProps={{ ...styles.button, ...(this.props.styleButton || {}) }}
                    onAction={this.onClickEdit}
                />
                {!!this.state.tid &&
                    <WActionButton
                        label='Löschen'
                        tooltip='Benutzerdefinierte Bezeichnung löschen'
                        key='delete'
                        action='delete'
                        style='small'
                        styleProps={{ ...styles.button, ...(this.props.styleButton || {}) }}
                        onAction={() => this.delData()}
                    />
                }
            </span>
        );
    }

    setData(name: string): void {
        const key_row: string = this.props.entity;
        const position: number = this.props.position;
        const tid: number = this.state.tid || 0;
        name = (name || '').trim();

        if (!name.length) {
            return;
        }
        this.dataService.setData(
            IDs.MOD_ETOOL, IDs.ENT_CUSTOM_ROW_NAME,
            { tid, name, key_row, position },
            (insertID: number) => this.setState(
                { tid: typeof insertID === 'number' ? insertID : tid, name },
                () => this.triggerService.fire('reload', IDs.ENT_CUSTOM_ROW_NAME)
            )
        );
    }
}
